import { render, staticRenderFns } from "./HealthScoreResults.vue?vue&type=template&id=297f3db3"
import script from "./HealthScoreResults.vue?vue&type=script&lang=js"
export * from "./HealthScoreResults.vue?vue&type=script&lang=js"
import style0 from "./HealthScoreResults.vue?vue&type=style&index=0&id=297f3db3&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports